//- Новости
const linkNews = document.getElementById('linkNews');
const filterNews = document.getElementById('filterNews');
const filterNewsBtns = document.querySelectorAll('input[name="news"]');
const listNewsEge = document.getElementById('listNewsEge');
const listNewsOther = document.getElementById('listNewsOther');
//- ЕГЭ боковая панель
const imgEge = document.getElementById('imgEge');
const egeNav = document.getElementById('egeNav');


let scroll = 0;


//если ссылка "новости образования" активна, то показать фильтры
if (linkNews && linkNews.classList.contains('active')){
	filterNews.classList.remove('hidden')
} 
//если ссылка "новости образования" активна, то убрать значок ЕГЭ и изменить порядок ссылок
if (linkNews && linkNews.classList.contains('active')){
	imgEge.style.display = 'none';
	egeNav.classList.add('other');
} 

//проверить чекнутый элемент
const check = (el) => {
	//if(el.checked) console.log(el.id)
	return el.checked ? el.id : false;
}
//в зависимости от значения радиобаттона показать блок
const changeInp = (val) => {
	if(val === 'radio_02') {
		listNewsEge.classList.add('show')
		listNewsOther.classList.remove('show')
	} else {
		listNewsEge.classList.remove('show')
		listNewsOther.classList.add('show')
	}
}

filterNewsBtns.forEach((radio) => {
	radio.addEventListener('click', () => {
		let v = check(radio)
		changeInp(v)
	})
})

//__________ПОИСК по бд_____________//

//выпадающий список для поля поиска
$('.search-input').on('input', function() {
	let val = $(this).val()

	//при очистке инпута очистить список подсказок и спрятать его
	if(val.length <= 1) {
		clearHints();
		$(this).next().addClass('hide');
	}

	if(val.length > 1) getHints(val);
	
	/* $('.search-input').on('blur', () => {
		$('.search__container').addClass('hide');
	}) */
}) 

 //на моб увеличить поле ввода на фокусе
$('.searchbar .search-input').on('focus', function() {
	$('.mob-search-form').css('max-width', '100%');
}) 

 //на моб уменьшить при потере фокуса
$('.searchbar .search-input').on('blur', function() {
	//if(!$(this).val()) $('.search-form').css('max-width', 'none');	
}) 

//чтобы на моб не дублировался поиск
export function makeOneSearch() {
	console.log('makeOneSearch')

	if(window.matchMedia('(max-width: 991px)').matches) {
		console.log('mob')
		$('.aside__search').find('.search-input').remove()
		$('.aside__search').find('.search__container').remove()
	} else {
		console.log('desc')
		$('.searchbar').find('.search-input').remove()
		$('.searchbar').find('.search__container').remove()
	}
}

//очистить список подсказок
function clearHints() {
	$('.search__container').find('ul').html('');
}

//заполнить список подсказок
function fillHints(names) {
	names.forEach(name => {
		$('.search__container').find('ul').append('<li>' + name + '</li>')
	})
}

//вставить подсказку в инпут
function insertValue() {
	//console.log('вставить подсказку в инпут')

	const list = $('.search__container').find('ul')

	list.on('click', function(e) {

		list.children('li').each(function(i, li){
			if(e.target === li) {

				$('.search-input').val($(e.target).text());
				$('.search-input').trigger('change');

				$('.search__container').addClass('hide');

				return false;
			}
		})	
	})
}

//выделить весь текст по двойному клику
$('.search-input').on('dblclick', function() {
	this.select()
}) 

function getHints(val) {

		$.ajax({
			url: "/ajax.php?mid=" + $('.search-form').attr('data-mid') + '&action=name_preview&text=' + val,
			type: 'POST',
			dataType: "json",
			success: function(data){
				let names = data.names;
				
				clearHints();
				fillHints(names);
				insertValue();


				if($('.search__container').hasClass('hide')) $('.search__container').toggleClass('hide');
				if(!data.names.length) $('.search__container').addClass('hide');
				if(data.names.length) $('.search__container').css('padding', '25px 7px 3px');
			},
			error: function(err){}
		});
		return false;

}